export default "__VITE_ASSET__B9X7LtFi__"